import React, {Component} from "react";
import {connect} from "react-redux";
import ReactSelect, {components} from "react-select";
import {
  setEventStatsLanguage,
} from "../../../actions/actions/eventStats";
import CheckBoxBtn from "../../common/Checkbox/CheckBoxBtn";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'}/>
    </components.DropdownIndicator>
  );
};

class LanguageFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };
  }

  handleSelectChange = (value) => {
    let languages = this.props.eventStatsFilter.language;
    const index = languages.indexOf(value);
    if(languages.includes("ALL")){
      languages = ['FR', 'EN', 'NL'];
      languages.splice(languages.indexOf(value), 1);
      this.props.setEventStatsLanguage(languages);
    } else if (index > -1) {
      if(languages.length == 1){
        return;
      } else {
        languages.splice(index, 1);
        this.props.setEventStatsLanguage(languages);
      }
    } else if (index == -1) {
      if(languages.length == 2){
        languages = ["ALL"];
        this.props.setEventStatsLanguage(languages);
      } else {
        languages.push(value);
        this.props.setEventStatsLanguage(languages);
      }
    }
  }

  handleChevronClick = () => {
    this.setState({showMenu : !this.state.showMenu});
  }

  render() {

    const pageSizeOptions = [
      { value: 'EN', label: 'ANGLAIS'},
      { value: 'FR', label: 'FRANÇAIS'},
      { value: 'NL', label: 'NEERLANDAIS'},
    ];

    return (
      <div className={'language-filter-container'}>
        <div className={'ml-3'}>Langues</div>
        <div className={'mr-3 ml-auto'}>
          <img src={"/img/icons/Polygon.svg"} className={this.state.showMenu && 'chevron-rotate'} onClick={() => this.handleChevronClick()}/>
        </div>
        {this.state.showMenu &&
          <div className={'language-menu'}>
            {pageSizeOptions.map((item, index) => (
              <div className="customed_select_body_item" key={index}>
                <div>
                  <CheckBoxBtn
                    id={item.value}
                    checked={this.props.eventStatsFilter.language.includes(item.value) || this.props.eventStatsFilter.language.includes('ALL')}
                    onChange={() => this.handleSelectChange(item.value)}
                  />
                </div>
                <div className="customed_select_body_item_label">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setEventStatsLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/LanguageFilter.js